export type MarkingPortalGeolocationError = 'unsupported' | 'denied' | 'unavailable' | 'timeout';

export interface MarkingPortalGeolocationPosition {
  lat: number;
  lng: number;
  accuracy?: number;
}

export type MarkingPortalGeolocationResult =
  | { success: true; position: MarkingPortalGeolocationPosition }
  | { success: false; error: MarkingPortalGeolocationError };

const mapGeolocationError = (code: number): MarkingPortalGeolocationError => {
  if (code === GeolocationPositionError.PERMISSION_DENIED) {
    return 'denied';
  }

  if (code === GeolocationPositionError.TIMEOUT) {
    return 'timeout';
  }

  return 'unavailable';
};

/**
 * Resolves the browser's current GPS position for marking portal check-in.
 */
export const getMarkingPortalGeolocation = (): Promise<MarkingPortalGeolocationResult> => {
  if (typeof navigator === 'undefined' || !navigator.geolocation) {
    return Promise.resolve({ success: false, error: 'unsupported' });
  }

  return new Promise(resolve => {
    navigator.geolocation.getCurrentPosition(
      position => {
        resolve({
          success: true,
          position: {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            accuracy: position.coords.accuracy,
          },
        });
      },
      error => {
        resolve({ success: false, error: mapGeolocationError(error.code) });
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0,
      },
    );
  });
};
